import React, { useEffect, useState } from 'react';
import { AddressSuggestions } from "react-dadata";
import { FioSuggestions } from 'react-dadata';
import { InputMask } from 'primereact/inputmask';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import burger_2 from '../../static/img/burger-2.png'

import { useDispatch, useSelector } from 'react-redux';
import { selectCalcPage, setShowPopUpManager } from './homeSlice';
import { selectName, selectRegAdr, setRegAdr } from '../calc/personSlice';
import { selectPhone, setPhone } from '../calc/calcSlice';
import { sendToManager } from './homeApi';

export function FormManager() {
    const dispatch = useDispatch()

    const [showMessengerSelecter, setShowMessengerSelecter] = useState(false);
    const [messenegr, setMessenegr] = useState('');
    const [comment, setComment] = useState('');

    const regAdr = useSelector(selectRegAdr)
    const [name, setName] = useState('');
    const phone = useSelector(selectPhone)
    const [stringDateBegin, setStringDateBegin] = useState('')

    const [success, setSuccess] = useState(false);

    const handleChangeRegAdr = (e) => {
        // dispatch(setKladrIdRegAddr(e.data.kladr_id))
        // dispatch(setFiasIdRegAddr(e.data.fias_id))
        dispatch(setRegAdr(e.value))
    }

    const handleChangeName = (e) => {
        setName(e.value)
    }

    const handleChangePhone = (e) => {
        dispatch(setPhone(e.target.value))
    }

    const handleChangeDateBegin = (e) => {
        setStringDateBegin(e.target.value)
    }

    const handleChangeComment = (e) => {
        setComment(e.target.value)
    }

    const handleClickTg = () => {
        setMessenegr('Телеграм')
        setShowMessengerSelecter(false)
    }

    const handleClickWa = () => {
        setMessenegr('Ватсап')
        setShowMessengerSelecter(false)
    }

    const handleClickVb = () => {
        setMessenegr('Вайбер')
        setShowMessengerSelecter(false)
    }

    const handleClickVk = () => {
        setMessenegr('Вконтакте')
        setShowMessengerSelecter(false)
    }

    const handleSendOrder = () => {
        const inp = document.getElementById('name_fm')
        // console.log('handleSendOrder', name || inp.value)
        window.ym(90426649,'reachGoal','clck_zayavk')
        sendToManager({
            name: name || inp.value,
            phone: phone,
            addres: regAdr,
            date_start: stringDateBegin,
            messenger: messenegr,
            comment: comment,
            checkedSelf: true,
        }, function (data) {
            window.ym(90426649,'reachGoal','zayavka_ok')
            // if (data.res) {
            //     window.ym(90426649,'reachGoal','zayavka_ok')
            //     setShowMessageSucces(true)
            // }
            // else {
            //     setShowMessageError(true)
            // }
        })
        // dispatch(setShowPopUpManager(false))
        setSuccess(true)
    }

    return (
        <>
            <div class="b-popup" id="popup">
                <div class="b-popup-vnutr"></div>
                <div class="b-popup-content">
                    <p class="popup-title">Оформление полиса</p>
                    {!success &&
                        <form class="form-popup">
                            <div class="one-ryad one-ryad-popup one-ryad-popup-1">
                                <label for="select-1">Имя</label>
                                {/* <input class="pole-popup pole-popup-1" name="Имя" type="text" placeholder="" required /> */}
                                <FioSuggestions
                                    inputProps={{
                                        className: "pole-popup pole-popup-1 addr_sugg",
                                        id: 'name_fm'
                                    }}
                                    token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                    defaultQuery={name}
                                    value={name}
                                    onChange={handleChangeName} />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-2">
                                <label for="select-1">Телефон</label>
                                {/* <input class="pole-popup pole-popup-2" name="Телефон" type="tel" placeholder="+7"
                                    pattern="^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$" required /> */}
                                <InputMask mask="+7(999) 999-9999"
                                    placeholder="+7(___) ___-____"
                                    className="pole-popup pole-popup-2"
                                    value={phone}
                                    onChange={handleChangePhone}
                                />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-3">
                                <div class="form-group">
                                    <div class="dropdown">
                                        <label for="select-1">Удобный способ связи</label>
                                        <button onClick={() => setShowMessengerSelecter(!showMessengerSelecter)} class="dropdown__button dropdown__button-popup">{messenegr}</button>
                                        {showMessengerSelecter &&
                                            <ul class="dropdown__list">
                                                <li onClick={handleClickTg} class="dropdown__list-item" data-value="Телеграм">Телеграм</li>
                                                <li onClick={handleClickWa} class="dropdown__list-item" data-value="Ватсап">Ватсап</li>
                                                <li onClick={handleClickVb} class="dropdown__list-item" data-value="Апартаменты">Вайбер</li>
                                                <li onClick={handleClickVk} class="dropdown__list-item" data-value="Апартаменты">ВКонтакте</li>
                                            </ul>
                                        }
                                        <input type="text" name="select-category" value="" class="dropdown__input-hidden" />
                                    </div>
                                </div>
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-4">
                                <label for="select-1">Адрес объекта</label>
                                {/* <input class="pole-popup pole-popup-1" name="Имя" type="text" placeholder="" required /> */}
                                <AddressSuggestions
                                    inputProps={{
                                        className: "pole-popup pole-popup-1 addr_sugg"
                                    }}
                                    token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                                    value={regAdr}
                                    onChange={handleChangeRegAdr} />

                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-5">
                                <label for="select-1">Дата начала действия полиса</label>
                                {/* <input class="pole-popup pole-popup-1" name="Имя" type="text" placeholder="ДД.ММ.ГГГГ" required /> */}
                                <InputMask mask="99.99.9999"
                                    placeholder="ДД.ММ.ГГГГ"
                                    className="pole pole-step-2 mask-date"
                                    id="pole-2.5"
                                    name="ostatok"
                                    value={stringDateBegin}
                                    onChange={handleChangeDateBegin} />
                            </div>
                            <div class="one-ryad one-ryad-popup one-ryad-popup-6">
                                <label for="select-1">Комментарий</label>
                                <input class="pole-popup pole-popup-1"
                                    value={comment}
                                    onChange={handleChangeComment}
                                    type="text" placeholder="" required
                                />
                            </div>
                            <button onClick={handleSendOrder} class="button button-1 button-popup-1">Оставить заявку</button>
                        </form>
                    }

                    {
                        success &&
                        <label style={{color: '#fff'}} for="select-1">
                            Мы получили ваш запрос, наш менеджер уже подбирает лучший вариант.<br /> 
                            Если вы не готовы ждать, можете
                            оформить полис на нашем сайте самостоятельно.
                        </label>
                    }
                    <div onClick={() => dispatch(setShowPopUpManager(false))} class="popup-close" ><img src={burger_2} alt="close" /></div>
                </div>
            </div>
        </>
    );
}



